export const layer = {
	layer: 'Layer',
	label: {
		appliances: 'Appliances',
		applianceDimensions: 'Appliance Dimensions',
		applianceLabels: 'Appliance Labels',
		backsplashes: 'Backsplashes',
		breakpoints: 'Breakpoints',
		corners: 'Corners',
		countertops: 'Countertops',
		cutouts: 'Cutouts',
		controls: 'Controls',
		islandDimensions: 'Island Dimensions',
		title: 'Title',
		islanadOverlaps: 'Island Overlaps',
		obstructions: 'Obstructions',
		overheadDimensions: 'Overhead Dimensions',
		panelInsideDimensions: 'Panel Inside Dimensions',
		panelOutsideDimensions: 'Panel Outside Dimensions',
		skuLayer: 'SKU Layer',
		developerInsights: 'Developer Insights'
	},
	tooltip: {
		show: 'Show',
		hide: 'Hide'
	},
	message: {

	}
};

export default layer;
